module.exports = __webpack_public_path__ + "static/media/Credits-4.8fb506f0.pdf";